import { Type } from 'class-transformer';

export class ViolationResultDto {
  category: string;
  status: string;
  location: string;
  regarding: string;
  violationId: string;
  @Type(() => Date)
  openCloseDate: Date;
  attorney: string;
  isOpen: boolean;
}
